/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { createMediaDataCollectionSchema } from './CreateMediaDataCollectionSchema'

export const createMediaDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	media: z.unknown(),
	collection: createMediaDataCollectionSchema,
	meta: z.array(z.string()).nullable().optional(),
})

export type CreateMediaDataSchema = z.infer<typeof createMediaDataSchema>
